import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function ServicesSection({ limit = 3, showHeader = true }) {
  const { t } = useLang();
  const list = services.slice(0, limit);
  return (
    <section className="py-24 bg-[#faf6ec]">
      <div className="max-w-[1280px] mx-auto px-6">
        {showHeader && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-12">
            <div>
              <p className="section-eyebrow mb-4">{t('serv.eyebrow')}</p>
              <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
                {t('serv.titlePre')} <span className="text-[#f5b300]">{t('serv.titleAccent')}</span>
              </h2>
            </div>
            <div className="flex flex-col lg:items-end gap-5">
              <p className="text-[15.5px] text-neutral-600 leading-relaxed max-w-md lg:text-right">{t('serv.desc')}</p>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 bg-[#f5b300] hover:bg-[#e0a200] text-[#14110f] font-semibold px-6 py-3 rounded-md shadow-[0_10px_28px_-10px_rgba(245,179,0,0.7)] hover:-translate-y-0.5 transition-all w-fit"
              >
                <ArrowRight className="w-4 h-4" /> {t('cta.allServices')}
              </Link>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            const featured = i === 0;
            return (
              <div
                key={s.id}
                className={`group relative rounded-xl p-8 transition-all duration-300 hover:-translate-y-1.5 cursor-pointer overflow-hidden ${
                  featured
                    ? 'bg-[#4a2e1a] text-white shadow-[0_25px_55px_-25px_rgba(74,46,26,0.6)]'
                    : 'bg-white text-[#14110f] hover:bg-[#4a2e1a] hover:text-white shadow-[0_18px_45px_-25px_rgba(20,17,15,0.18)]'
                }`}
              >
                <div className="absolute -top-12 -right-12 w-44 h-44 rounded-full bg-[#f5b300]/8 group-hover:bg-[#f5b300]/12 transition-colors" />
                <div className={`w-16 h-16 rounded-lg flex items-center justify-center mb-7 ${featured ? 'bg-[#f5b300]' : 'bg-[#f5b300]/15 group-hover:bg-[#f5b300]'}`}>
                  <Icon className={`w-8 h-8 ${featured ? 'text-[#14110f]' : 'text-[#c89200] group-hover:text-[#14110f]'}`} strokeWidth={1.7} />
                </div>
                <h3 className={`text-[20px] font-bold mb-3 ${featured ? 'text-white' : 'group-hover:text-white'}`}>
                  {t(`service.${s.id}.title`)}
                </h3>
                <p className={`text-[14px] leading-relaxed mb-7 ${featured ? 'text-white/70' : 'text-neutral-500 group-hover:text-white/70'}`}>
                  {t(`service.${s.id}.short`)}
                </p>
                <Link
                  to="/services"
                  className={`inline-flex items-center gap-1.5 text-[13.5px] font-semibold uppercase tracking-wide ${
                    featured ? 'text-[#f5b300]' : 'text-[#c89200] group-hover:text-[#f5b300]'
                  }`}
                >
                  {t('cta.learnMore')} <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
